import { usePrintMethod } from '@/hooks/useGeneralSettings'
import { useLocalPrintAgent, isLocalPrintAgentOnline } from '@/hooks/useLocalPrintAgent'

export function PrintAgentBadge() {
  const printMethod = usePrintMethod()
  const { data: local, isLoading } = useLocalPrintAgent()

  if (printMethod === 'browser') {
    return (
      <span className="text-xs px-2 py-1 rounded-full bg-blue-100 text-blue-800">
        Печать: браузер
      </span>
    )
  }

  if (isLoading) {
    return <span className="text-xs text-gray-400">Агент…</span>
  }

  if (!isLocalPrintAgentOnline(local)) {
    return (
      <span className="text-xs px-2 py-1 rounded-full bg-amber-100 text-amber-800">
        Локальный агент offline
      </span>
    )
  }

  const scanHint = local!.scan_port ? ` · COM ${local!.scan_port}` : ''

  return (
    <span
      className="text-xs px-2 py-1 rounded-full bg-green-100 text-green-800"
      title={`КМ: ${local!.printer_km || '—'} · КА: ${local!.printer_ka || '—'}${scanHint}`}
    >
      Агент: {local!.agent_id}{scanHint}
    </span>
  )
}
